import React from "react"
import NumberFormat from "react-number-format"
import { Formik, Form as FormikForm, Field } from "formik"
import { Row, Form, Col } from "react-bootstrap"
import * as Yup from "yup"
import FormTextbox from "../../shared/formTextbox"
import FormFieldDisableAutoComplete from "../../shared/formFieldDisableAutoComplete"
import FormDatePickerTextBox from "../../shared/formDatePickerTextBox"
import FormTimeTextBox from "../../shared/formTimeTextBox"
import FormSectionTitle from "../../shared/formSectionTitle"
import FormAmountTextBox from "../../shared/formAmountTextBox"
import format from "date-fns/format"
import { fillMedicalDetailAlert } from "../../../services/sweetalertService"

import FormDropdownList from "../../shared/formDropdownList"
import FormEditUpload from "../../shared/formEditUpload"

import {
  controlEditBenefit,
  updateValidBenfitFormData,
  updateClickedNext,
  updateFormIsValid,
  pageIncrement,
  completeBenefitForm,
  addBenefitItem,
} from "../../../redux/actions"

import * as Constants from "../../../common/constants"
import * as Regex from "../../../common/regex"
import * as ErrorMessage from "../../../common/errorMessage"
import * as CommonFunction from "../../../common/function"
import * as Alert from "../../../services/sweetalertService"

import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"

const MedicalExpensesForm = ({ coverageDetail }) => {
  const dispatch = useDispatch()
  const formRef = React.useRef()

  const {
    editBenefits,
    allProofDocuments,
    claimUploadListModel,
    clickedNext,
    isComeWithChildCoverage,
    tempBenefitInfo,
    pageNumber,
    chosenedBenefits,
  } = useSelector(state => state.uiData)

  const claimData = useSelector(state => state.claimData)

  const {
    Category: coverageCategory,
    CoverageCode: coverageCode,
    CoverageDetailId: coverageDetailId,
    CoverageDetailName: coverageDetailName,
  } = coverageDetail

  const formName = coverageCode

  //PA dropdown data
  const { TypeOfDoctor } = useSelector(state => state.dropdownData)

  const [medicalDetailList, setMedicalDetailList] = React.useState([])

  useSelector(state => {
    if (!state.claimData[coverageCategory][coverageCode]) {
      state.claimData[coverageCategory][coverageCode] = {}
    }
  }, shallowEqual)

  const validationSchema = Yup.object().shape({
    occurrenceDate: Yup.date().required(ErrorMessage.MedicalAccidentDate),
    occurrenceTime: Yup.string()
      .required(ErrorMessage.MedicalAccidentTime)
      .matches(Regex.timepattern, ErrorMessage.MedicalAccidentTime)
      .test("occurrenceTime", ErrorMessage.futureTimeErrorMsg, value => {
        return CommonFunction.notFutureDatime(
          formRef.current.values.occurrenceDate,
          value
        )
      }),

    occurrenceDescription: Yup.string().required(
      ErrorMessage.MedicalAccidentDescription
    ),

    occurrenceLocation: Yup.string().required(
      ErrorMessage.MedicalAccidentLocation
    ),

    occurrenceNature: Yup.string().required(ErrorMessage.MedicalInjuryNature),

    // childName: Yup.string().when("coverageCode", {
    //   is: "AMCIM",
    //   then: Yup.string().required(ErrorMessage.childName),
    // }),
    // childBirthDate: Yup.date().when("coverageCode", {
    //   is: "AMCIM",
    //   then: Yup.date().required(ErrorMessage.childBirthDate),
    // }),
    // childNRIC: Yup.string().when("coverageCode", {
    //   is: "AMCIM",
    //   then: Yup.string()
    //     .required(ErrorMessage.childNRIC)
    //     .matches(Regex.nricpattern, ErrorMessage.childNRIC),
    // }),

    claimAmount: Yup.number()
      .transform(value => (isNaN(value) ? undefined : value))
      .min(1, ErrorMessage.claimAmount),
  })

  const updateBenefitClaimAmount = medicalList => {
    let totalAmount = 0

    medicalList.forEach((medicalListItem, medicalListKey) => {
      totalAmount += medicalListItem.claimAmount
    })

    return totalAmount
  }

  function addMedicalDetailEvent(values) {
    if (
      values.medicalType &&
      values.receiptDate &&
      values.netClaimAmount &&
      values.netClaimAmount >= 1
    ) {
      let copyOfMedicalList = Object.assign([], medicalDetailList)
      let index = new Date().getTime().toString()

      copyOfMedicalList.push({
        index: index,
        medicalType: values.medicalType,
        receiptDate: values.receiptDate,
        claimAmount: values.netClaimAmount,
      })

      setMedicalDetailList(copyOfMedicalList)

      formRef.current.setFieldValue("medicalType", "")
      formRef.current.setFieldValue("netClaimAmount", 0)
      formRef.current.setFieldValue(
        "claimAmount",
        updateBenefitClaimAmount(copyOfMedicalList)
      )
    } else {
      fillMedicalDetailAlert()
    }
  }

  function removeMedicalDetailEvent(index) {
    let copyOfMedicalList = Object.assign([], medicalDetailList)
    let indexToRemove = copyOfMedicalList.findIndex(x => x.index === index)
    copyOfMedicalList.splice(indexToRemove, 1)
    setMedicalDetailList(copyOfMedicalList)
    formRef.current.setFieldValue(
      "claimAmount",
      updateBenefitClaimAmount(copyOfMedicalList)
    )
  }

  React.useEffect(() => {
    formRef.current.setFieldValue("coverageCode", coverageCode)

    if (coverageCode === "AMFR" || coverageCode === "AMSG") {
      formRef.current.setFieldValue("occurrenceNature", coverageDetailName)
    }
  }, [])

  return (
    <Formik
      initialValues={Object.assign(
        {
          occurrenceDate: "",
          occurrenceTime: "",
          occurrenceDescription: "",
          occurrenceLocation: "",
          occurrenceNature: "",
          // childName: "",
          // childBirthDate: "",
          // childNRIC: "",
          claimAmount: 0,
        },
        claimData[coverageCategory][coverageCode]
      )}
      enableReinitialize={true}
      validationSchema={validationSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ values }) => (
        <>
          <FormikForm>
            {
              <Row
                className={
                  "form-group " + (editBenefits[coverageCode] ? "" : "hide")
                }
              >
                <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                  <p>{coverageDetailName}</p>
                </div>
                <div className="col-md-3 col-5 marginTop10px">
                  <div
                    className="cursorPointer"
                    role="button"
                    tabIndex="0"
                    onClick={() => dispatch(controlEditBenefit(coverageCode))}
                  >
                    <p className="doneEdit">DONE EDIT</p>
                  </div>
                </div>
              </Row>
            }
            {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
            <Field
              textDesc={"Disable Auto Complete"}
              name="disableAutoComplete"
              component={FormFieldDisableAutoComplete}
            />
            <Field
              textDesc={"Date of Accident"}
              name="occurrenceDate"
              component={FormDatePickerTextBox}
              disabled={medicalDetailList.length > 0 ? true : false}
            />
            <Field
              textDesc="Time of Accident (HH:mm)"
              name="occurrenceTime"
              component={FormTimeTextBox}
            />
            <Field
              textDesc={"Description of Accident"}
              maxLength={3000}
              name="occurrenceDescription"
              component={FormTextbox}
            />
            <Field
              textDesc={"Location of Accident (City, Country)"}
              maxLength={100}
              name="occurrenceLocation"
              component={FormTextbox}
            />
            <Field
              disabled={coverageCode === "AMFR" || coverageCode === "AMSG"}
              textDesc={"Nature of Injury"}
              maxLength={200}
              name="occurrenceNature"
              component={FormTextbox}
            />

            {/* Add a hidden input for yup validation can get coverageCode value */}
            {"" && (
              <Field
                textDesc="Coverage Code"
                maxLength={100}
                name="coverageCode"
                component={FormTextbox}
              />
            )}

            {/* {isComeWithChildCoverage && coverageCode === "AMCIM" && (
              <>
                <FormSectionTitle text={"Child Details"} />

                <Field
                  textDesc="Name of Child"
                  maxLength={100}
                  name="childName"
                  component={FormTextbox}
                />
                <Field
                  textDesc={"Date of Birth"}
                  name="childBirthDate"
                  component={FormDatePickerTextBox}
                />
                <Field
                  textDesc={"Child NRIC"}
                  maxLength={9}
                  name="childNRIC"
                  component={FormTextbox}
                  toUpperCase={true}
                />
              </>
            )} */}

            {/* Add Medical Details */}
            <Form.Group>
              <Row>
                <Col className="font-weight-bold">
                  {"Add Medical Details/Expenses"}
                </Col>
              </Row>
            </Form.Group>
            <Field
              textDesc="Type of Doctor"
              name="medicalType"
              component={FormDropdownList}
              dropdownItem={TypeOfDoctor}
            />
            <Field
              textDesc="Receipt Date"
              name="receiptDate"
              component={FormDatePickerTextBox}
              disableBefore={"occurrenceDate"}
              // disableAfter={"occurrenceDate"}
              disabled={values.occurrenceDate !== "" ? false : true}
            />
            <Field
              textDesc="Claim Amount"
              name="netClaimAmount"
              component={FormAmountTextBox}
              maxLength={14}
            />
            <Form.Group>
              <Row>
                <Col md="7" lg="7" className="textforinput marginTop10px">
                  <p className={medicalDetailList.length > 0 ? "" : "hide"}>
                    <b>{"Medical Details/Expenses"}</b>
                  </p>
                </Col>
                <Col
                  md="5"
                  lg="5"
                  className="marginTop10px"
                  id="divDescMake"
                  align="right"
                  style={{ lineHeight: "50px" }}
                >
                  <div
                    className="btn btn-success btn-round btnAddItem"
                    onClick={addMedicalDetailEvent.bind(this, values)}
                    onKeyDown={addMedicalDetailEvent.bind(this, values)}
                    style={{ width: "80%" }}
                    tabIndex="0"
                    role="button"
                  >
                    <span id="btnAddItem">
                      <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                      &nbsp;Add
                    </span>
                  </div>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group>
              <Row className={medicalDetailList.length > 0 ? "" : "hide"}>
                <Col className="table-responsive">
                  <table className="table">
                    <tbody>
                      <tr>
                        <th className="text-center" scope="col">
                          Type of doctor
                        </th>
                        <th className="text-center" scope="col">
                          Receipt Date
                        </th>
                        <th className="text-center" scope="col">
                          Claim Amount
                        </th>
                        <th className="text-center" scope="col">
                          Remove
                        </th>
                      </tr>
                      {medicalDetailList.map(item => (
                        <tr key={item.index}>
                          <td className="text-center">{item.medicalType}</td>
                          <td className="text-center">
                            {format(item.receiptDate, "dd/MM/yyyy")}
                          </td>
                          <td className="text-center">
                            <NumberFormat
                              value={item.claimAmount}
                              displayType={"text"}
                              thousandSeparator={true}
                              prefix={"S$"}
                            />
                          </td>
                          <td className="text-center">
                            <div
                              className="btn btn-danger btn-fab btn-fab-mini btn-round"
                              style={{ paddingTop: "7px" }}
                              onClick={removeMedicalDetailEvent.bind(
                                this,
                                item.index
                              )}
                              onKeyDown={removeMedicalDetailEvent.bind(
                                this,
                                item.index
                              )}
                              tabIndex="0"
                              role="button"
                            >
                              <i className="fa fa-minus" aria-hidden="true"></i>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </Form.Group>
            {/* END of Add Medical Details */}

            <Field
              disabled={true}
              textDesc={"Amount Claimed(SGD)"}
              maxLength={14}
              name="claimAmount"
              component={FormAmountTextBox}
            />
            <FormEditUpload
              pageTo={Constants.benefitRequiredDocumentPageNumber}
              editBenefits={editBenefits[coverageCode]}
              coverageDetailId={coverageDetailId}
              coverageDetailName={coverageDetailName}
              allProofDocuments={allProofDocuments}
              claimUploadListModel={claimUploadListModel}
            />
            <HandleFormValidation
              thisPageClickedNext={clickedNext[Constants.benefitFormPageNumber]}
              reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
              formRef={formRef}
              values={values}
              thisPageNumber={Constants.benefitFormPageNumber}
              dispatch={dispatch}
              formName={formName}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              tempBenefitInfo={tempBenefitInfo}
              itemList={medicalDetailList}
              chosenedBenefits={chosenedBenefits}
            />
            <HandleClaimAmountUpdate
              claimAmount={values.claimAmount}
              dispatch={dispatch}
              pageNumber={pageNumber}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              medicalDetailList={medicalDetailList}
              formRef={formRef}
            />
            <SetItemDate
              triggerDate={values.occurrenceDate}
              effectDate={"receiptDate"}
              formRef={formRef}
            />
          </FormikForm>
        </>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  formName,
  coverageCategory,
  coverageCode,
  tempBenefitInfo,
  itemList,
  chosenedBenefits,
}) => {
  React.useEffect(() => {
    if (
      (thisPageClickedNext && coverageCode === tempBenefitInfo.CoverageCode) ||
      (reviewPageClickedNext &&
        CommonFunction.checkBenefitChosened(chosenedBenefits, coverageCode))
    ) {
      formRef.current.validateForm().then(errors => {
        // console.log(errors)

        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")

            dispatch(
              updateValidBenfitFormData(coverageCategory, coverageCode, values)
            )
            dispatch(
              addBenefitItem(
                coverageCategory,
                coverageCode,
                "MedicalDetailList",
                itemList
              )
            )

            if (thisPageClickedNext) {
              dispatch(pageIncrement())
              dispatch(completeBenefitForm(coverageCode))
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
            } else {
              dispatch(updateFormIsValid(formName, false))
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [values, thisPageClickedNext, reviewPageClickedNext])
  return null
}

const HandleClaimAmountUpdate = ({
  claimAmount,
  dispatch,
  pageNumber,
  coverageCategory,
  coverageCode,
  medicalDetailList,
  formRef,
}) => {
  React.useEffect(() => {
    if (pageNumber === Constants.reviewPageNumber) {
      setTimeout(() => {
        batch(() => {
          dispatch(
            updateValidBenfitFormData(
              coverageCategory,
              coverageCode,
              formRef.current.values
            )
          )
          dispatch(
            addBenefitItem(
              coverageCategory,
              coverageCode,
              "MedicalDetailList",
              medicalDetailList
            )
          )
        })
      }, 1000)
    }
  }, [claimAmount])

  return null
}

const SetItemDate = ({ triggerDate, effectDate, formRef }) => {
  React.useEffect(() => {
    if (triggerDate) {
      formRef.current.setFieldValue(effectDate, triggerDate)
    }
  }, [triggerDate])

  return null
}
export default MedicalExpensesForm
